<template>
	<div>
		<div class="quiz">
			<div class="module__wrapper module__wrapper--between">
				<div>
					Question <span class="bold">{{currentQuizIndex+1}}/{{quizzes.length}}</span>
				</div>
			</div>
			<div class="quiz__main">
				<template v-if="quizIntro">
					<div class="center">
						<h4>Welcome to the module quiz</h4>
						<p class="pb-10">Click the button below to start your quiz</p>
						<button @click="startQuiz" type="button" class="btn__primary btn__primary--alt">Start</button>
					</div>
				</template>
				<template v-if="quizStart">
					<div class="quiz__heading">
						<h4 class="quiz__primary"></h4>
						<h5 class="quiz__secondary">Please answer all question.</h5>
					</div>
					<div class="quiz__body">
						<form @submit.prevent="submitQuiz" class="form__quiz" action="">
							<Question 
								:question="quizzes[currentQuizIndex]"
								:question-index="currentQuizIndex + 1"
								:reset="reset"/>
							<template v-if="currentQuizIndex === (quizzes.length - 1)">
								<button 
									type="submit" 
									class="btn btn__quiz"
									@click.prevent="submitQuiz">Submit
								</button>
							</template>
							<template v-else>
								<button
									@click.prevent="nextQuiz"
									type="submit" 
									class="btn btn__quiz">Next</button>
							</template>
						</form>
					</div>
				</template>
				<template v-if="quizSubmitted">
					<div class="center">
						<h4>Well done!</h4>
						<p>Your score is {{percentage}}%</p>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import Question from './Question';
import eventHub from '../../utils/eventhub';

export default {
	name: 'ModuleQuiz',
	props: {
		quiz: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data() {
		return {
			quizzes: this.quiz,
			currentQuizIndex: 0,
			quizStart: false,
			quizSubmitted: false,
			score: 0,
			quizIntro: true,
			reset: false,
			percentage: 0
		};
	},
	created() {
		eventHub.$on('result', (payload) => {
			this.score += payload;
		});
	},
	watch: {
		score(value) {
			this.percentage = (value / this.quizzes.length).toFixed(2) * 100;
		}
	},
	methods: {
		submitQuiz() {
			this.quizStart = false;
			this.quizSubmitted = true;
		},
		nextQuiz() {
			this.currentQuizIndex += 1;
			this.reset = true;
			setTimeout(() => {
				this.reset = false;
			}, 500);
		},
		startQuiz() {
			this.quizIntro = false;
			this.quizStart = true;
		}
	},
	components: {
		Question
	}
};
</script>

<style lang="scss" scoped>
.center {
	text-align: center;
}
</style>
